<template>
  <div class="add-edit-instrument instrument-modal-window"
       cy="add-instruments-modal">

    <h2>
      Adaugă
    </h2>

    <div class="tab-menu flex flex-center"
         cy="tab-menu">
      <button :class="{'selected-tab': view === 'instrument'}"
              @click="handleView('instrument')">
        instrument
      </button>

      <button cy="select-set-view"
              :class="{'selected-tab': view === 'set'}"
              @click="handleView('set')">
        set
      </button>
    </div>

    <form @submit.prevent="handleSubmit">
      <label for="name">
        <span class="block">
          nume {{ view }}*
        </span>

        <input id="name"
               cy="name"
               type="text"
               placeholder="nume instrument"
               @input="handleInput($event, 'name')" />
      </label>

      <label for="id">
        <span class="block">
          ID:
        </span>

        <input id="id"
               cy="id"
               type="text"
               placeholder="id instrument"
               @input="handleInput($event, 'id')" />
      </label>

      <div v-if="view === 'set'">
        <label for="">
          <span class="block">
            Instrumente
          </span>
          <select @change="handleAddInstrumentToSet"
                  cy="select-instrument">
            <option value=""
                    selected disabled>
              selectati instrument
            </option>

            <option :value="name"
                    v-for="({ name }, index) in instruments"
                    :key="index">
              {{ name }}
            </option>
          </select>
        </label>

        <ul cy="selected-instruments-list"
            class="selected-instruments">
          <li v-for="(item, index) in selectedInstrumentsForSet"
              :key="index">
            <span>
              {{ item }}
            </span>
            <button type="button"
                    @click="handleRemoveInstrumentFromSet(item)">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z" fill="white"/>
              </svg>
            </button>
          </li>
        </ul>
      </div>

      <div class="actions-bar flex">
        <button type="button"
                cy="cancel"
                @click="handleCancel">
          Cancel
        </button>

        <button cy="save">
          Salveaza
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'AddEditInstrument',
    props: {
      instruments: Array
    },
    data () {
      return {
        data: {name: '', id: ''},
        view: 'instrument',
        selectedInstrumentsForSet: []
      }
    },
    methods: {
      handleView (view) {
        this.view = view;
      },
      handleCancel () {
        this.$emit('close')
      },
      handleInput (ev, name) {
        this.data[name] = ev.target.value;
      },
      handleAddInstrumentToSet (ev) {
        this.selectedInstrumentsForSet.push(ev.target.value);
      },
      handleRemoveInstrumentFromSet (item) {
        const index = this.selectedInstrumentsForSet.findIndex(val => item === val);
        this.selectedInstrumentsForSet.splice(index, 1);
      },
      handleSubmit () {
        if (this.view === 'set') {
          this.data.type = 'set';
          this.data.instruments = this.selectedInstrumentsForSet;
        }
        this.$emit('submit', this.data);
      },
    }
  }
</script>

<style lang="less">
  .add-edit-instrument {
    @media only screen and (min-width: 0) {
      .tab-menu {
        margin-bottom: 24px;
        button {
          height: 28px;
          width: 150px;
          border: none;
          font-size: 1.5rem;
          border-radius: 4px;
          text-align: center;
          background-color: #D9D9D9;
        }
        .selected-tab {
          background-color: #5E5E5E;
          color: white;
        }
      }
      form {
        select {
          width: 100%;
          padding: 6px 10px;
          border: 1px solid #dddddd;
          border-radius: 4px;
          font-size: 1.6rem;
        }
        .selected-instruments {
          font-size: 1.7rem;
          li {
            margin-bottom: 8px;
            button {
              border: none;
              border-radius: 4px;
              background-color: #959595;
              color: white;
            }
          }
        }
      }
    }
  }
</style>
